// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cLqj2","container__label":"styles_container__label__jIMf2","skeleton-animation":"styles_skeleton-animation__d74MC"};